<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="webcast" :label="$t('webinar')" icon="fal fa-broadcast-tower" />

            <q-tab-pane name="webcast" class="q-px-md q-pb-xl q-mt-md">
                <div>
                    <div class="row gutter-sm" v-if="$q.platform.is.desktop">
                        <div class="col-sm-11">
                            <p class="q-title">{{ title }}</p>
                            <p class="q-body-1 text-weight-light">{{ description }}</p>
                            <p class="q-body-1 text-weight-light">{{ `${$t('timezone')}: ${timezone}` }}</p>
                        </div>

                        <div class="col-sm-1 cursor-pointer" @click="showCertificate()">
                            <vc-donut :sections="sections" :size="100" unit="%">
                                <h6 v-if="user_progress < 100 && webcast_user_result_status != 1 && webcast_user_result_status != 2" class="text-primary">
                                    {{ getPercentage(user_progress) }}%
                                </h6>

                                <q-icon :name="getResult" :color="getResultColor" size="2rem" v-if="user_progress == 100 || webcast_user_result_status == 1 || webcast_user_result_status == 2" />

                                <q-tooltip v-if="webcast_user_result_status == 2">
                                    {{ `${$t('you_were_reproved_in')} ${webcast_user_result_date}` }}
                                </q-tooltip>
                            </vc-donut>
                        </div>
                    </div>

                    <div class="row gutter-xs" v-if="$q.platform.is.mobile">
                        <div class="col-xs-10">
                            <p class="q-title">{{ title }}</p>
                        </div>

                        <div class="col-xs-2" @click="showCertificate()">
                            <vc-donut :sections="sections" :size="100" unit="%">
                                <h6 v-if="user_progress < 100 && webcast_user_result_status != 1 && webcast_user_result_status != 2" class="text-primary">
                                    {{ getPercentage(user_progress) }}%
                                </h6>

                                <q-icon :name="getResult" :color="getResultColor" size="1.5rem" v-if="user_progress == 100 || webcast_user_result_status == 1 || webcast_user_result_status == 2" />

                                <q-tooltip v-if="webcast_user_result_status == 2">
                                    {{ `${$t('you_were_reproved_in')} ${webcast_user_result_date}` }}
                                </q-tooltip>
                            </vc-donut>
                        </div>

                        <div class="col-xs-12 col-sm-11">
                            <p class="q-body-1 text-weight-light">{{ description }}</p>
                            <p class="q-body-1 text-weight-light">{{ `${$t('timezone')}: ${timezone}` }}</p>
                        </div>
                    </div>

                    <div class="row reverse gutter-sm q-mt-sm">
                        <div class="col-xs-12 col-sm-2">
                            <q-btn :label="$t('back')" color="primary" icon="far fa-chevron-left" class="full-width" @click="$router.push({ name: 'webcasts' })" />
                        </div>
                    </div>

                    <q-tabs v-model="tab_webcast" color="primary" underline-color="secondary" align="justify" class="q-mt-md">
                        <!-- <q-tab slot="title" name="webcasts" :label="$q.platform.is.desktop ? `${$t('webinar')}` : ''" icon="fal fa-broadcast-tower" /> -->
                        <q-tab slot="title" name="activities" :label="$q.platform.is.desktop ? `${$t('activities')} (${qty_webcast_activities})` : ''" icon="fal fa-pen" />

                        <q-tab slot="title" name="reaction_test" :label="$q.platform.is.desktop ? `${$t('reaction_test')} (${qty_webcast_evaluations})` : ''" icon="fal fa-clipboard-list-check" />

                        <q-tab-pane name="activities" class="q-px-md q-pb-md">
                            <q-table
                                ref="table"
                                :pagination.sync="server_pagination"
                                :data="activities"
                                :columns="columns"
                                @request="requestActivities"
                                :loading="loading"
                                row-key="id"
                                :no-data-label="$t('no_data_avaliable')"
                                :no-results-label="$t('no_results_found')"
                                :loading-label="$t('loading_data')"
                                :rows-per-page-label="$t('items_per_page')"
                                :rows-per-page-options="[0]"
                                hide-bottom
                                class="shadow-0"
                                v-if="$q.platform.is.desktop"
                                >

                                <q-tr slot="header" slot-scope="props" :props="props">
                                    <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                    {{ $t(col.label) }}
                                    </q-th>
                                </q-tr>

                                <template slot="body" slot-scope="props">
                                    <q-tr :props="props" :class="getRowClass(props.row)">
                                        <q-td key="type_title" :props="props">
                                            {{ props.row.type_title }}
                                        </q-td>

                                        <q-td key="type_slug" :props="props">
                                            <q-icon :name="getIcon(props.row.type_slug)" size="1rem" class="q-mr-sm" />
                                            {{ $t(getType(props.row.type_slug)) }}
                                        </q-td>

                                        <q-td key="score" :props="props">
                                            {{ props.row.score }}
                                        </q-td>

                                        <q-td key="user_watch" :props="props" auto-width>
                                            <q-icon name="fal fa-ban" size="1.5rem" color="negative" v-if="props.row.is_blocked" />
                                            <q-icon name="fal fa-circle" size="1.5rem" color="primary" v-else-if="props.row.type_slug == 'webcast' && !props.row.user_watch || props.row.type_slug !== 'webcast' && !props.row.is_approved" />
                                            <q-icon name="fal fa-check-circle" size="1.5rem" color="positive" v-else-if="props.row.is_approved || props.row.user_watch && props.row.type_slug == 'webcast'" />
                                        </q-td>

                                        <q-td key="actions" :props="props">
                                            <q-btn color="primary" class="full-width" :label="$t(getLabelBtn(props.row))" :icon="getIconBtn(props.row)" @click="btnClicked(props.row)" :disable="getDisableButton(props.row)" />
                                        </q-td>
                                    </q-tr>
                                </template>
                            </q-table>

                            <q-card class="bg-grey-1 q-mt-md" v-for="(activity, index) in activities" :key="index" :class="getRowClass(activity)" v-if="$q.platform.is.mobile">
                                <q-card-main class="relative-position">
                                    <div class="line-card bg-primary absolute-top"></div>

                                    <div class="row gutter-sm vertical-middle">
                                        <div class="col-9">
                                            <p>
                                                <q-icon name="fal fa-ban" size="1rem" color="negative" v-if="activity.is_blocked" />
                                                <q-icon name="fal fa-circle" size="1rem" color="positive" v-else-if="activity.type_slug == 'webcast' && !activity.user_watch || activity.type_slug !== 'webcast' && !activity.is_approved" />
                                                <q-icon name="fal fa-check-circle" size="1rem" color="primary" v-else-if="activity.is_approved || activity.user_watch && activity.type_slug == 'webcast'" />
                                                <span class="q-ml-sm q-subheading">{{ activity.type_title }}</span>
                                            </p>
                                        </div>

                                        <div class="col-3 text-right">
                                            <q-icon :name="getIcon(activity.type_slug)" size="3rem" color="secondary" />
                                        </div>
                                    </div>
                                </q-card-main>

                                <q-card-separator />

                                <q-card-actions>
                                    <q-btn color="primary" class="full-width" :label="$t(getLabelBtn(activity))" :icon="getIconBtn(activity)" @click="btnClicked(activity)" :disable="getDisableButton(activity)" />
                                </q-card-actions>
                            </q-card>
                        </q-tab-pane>

                        <q-tab-pane name="reaction_test" class="q-px-md q-pb-xl q-mt-md">
                            <reaction-test />
                        </q-tab-pane>

                    </q-tabs>
                </div>
            </q-tab-pane>
        </q-tabs>

        <q-modal v-if="show_modal_webcast" v-model="show_modal_webcast" :content-css="{minWidth: '100vw', minHeight: '100vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalWebcast()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ selected_webcast.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <webcast v-if="show_modal_webcast" :webcast="selected_webcast" :live="firebase_webcast_data" />
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="show_modal_test" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalTest()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ test.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <test :test="test" v-if="test" @clearTest="hideModalTest" />
            </q-modal-layout>
        </q-modal>

        <!-- <q-modal v-model="show_modal_reaction_test" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalTest()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ test.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <reaction-test :test="test" v-if="test" @clearTest="hideModalTest" />
            </q-modal-layout>
        </q-modal> -->

        <certificate :show="show_certificate" :data="certificate_data" :certificate="certificate" @hideCertificate="hideCertificate" />
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Test from 'components/webcasts/Test'
import ReactionTest from 'components/webcasts/ReactionTest'
import Certificate from 'components/webcasts/Certificate'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import { db } from 'plugins/vuefire'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'courses', 'webcast'] },

    data() {
        return {
            tab: 'webcast',
            tab_webcast: 'activities',
            title: '',
            timezone: '',
            description: '',
            user_progress: 0,
            sections: [],
            show_certificate: false,
            certificate_data: [],
            certificate: {},
            webcast_user_result_status: null,
            webcast_user_result_date: '',
            webcast: [],
            qty_webcast_activities: 0,
            qty_webcast_evaluations:0,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            },
            columns: [
                {
                    name: 'type_title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'type_title',
                    sortable: false,
                },
                {
                    name: 'type_slug',
                    required: true,
                    label: 'type_activity',
                    align: 'left',
                    field: 'type_slug',
                    sortable: false,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: false,
                },
                {
                    name: 'user_watch',
                    required: true,
                    label: 'status',
                    align: 'center',
                    field: 'user_watch',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'actions',
                    sortable: false,
                }
            ],
            loading: false,
            activities: [],
            show_modal_webcast: false,
            selected_webcast: {},
            test: {},
            show_modal_test: false,
            show_modal_reaction_test: false,
            webcast_status: '',
            webcast_type: null,
            firebase_webcast_data: null,
            webcast_user_subscribed: false
        }
    },

    components: {
        'webcast': () => import('components/webcasts/Webcast.vue'),
        'test': Test,
        'reaction-test': ReactionTest,
        'certificate': Certificate
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getResult() {
            if (this.webcast_user_result_status == 1) {
                return 'fal fa-trophy'
            }
            else if (this.webcast_user_result_status == 2) {
                return 'fal fa-ban'
            }
        },

        getResultColor() {
            if (this.webcast_user_result_status == 1) {
                return 'positive'
            }
            else if (this.webcast_user_result_status == 2) {
                return 'negative'
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '90vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        }
    },

    methods: {
        requestActivities({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            this.$axios.all([this.fetchWebcast(), this.fetchTests()])
            .then(this.$axios.spread((webcasts, tests) => {
                this.activities = []

                this.title = webcasts.data.title
                this.description = webcasts.data.description
                this.timezone = this.getHumanTimezone(webcasts.data.timezone)

                this.webcast_user_subscribed = webcasts.data.webcast_user_subscribed
                this.webcast_status = webcasts.data.status
                this.webcast_type = webcasts.data.webcast_type
                this.transmission_downloaded = webcasts.data.transmission_downloaded
                this.webcast_id = webcasts.data.id
                this.qty_webcast_evaluations = webcasts.data.qty_webcast_evaluations
                this.webcast_user_result_status = webcasts.data.webcast_user_result_status
                this.webcast_user_result_date = date.formatDate(webcasts.data.webcast_user_user_result_date, 'DD/MM/YYYY')
                this.user_progress = parseInt(webcasts.data.user_progress)

                this.activities.push({
                    id: webcasts.data.id,
                    type_title: webcasts.data.title,
                    type_slug: 'webcast',
                    user_watch: webcasts.data.user_watch,
                    score: webcasts.data.score > 0 ? webcasts.data.score : '',
                    actions: webcasts.data.id
                })

                tests.data.forEach(test => {
                    this.activities.push({
                        id: test.id,
                        type_title: test.title,
                        type_slug: test.type_slug,
                        user_watch: webcasts.data.user_watch,
                        actions: test.id,
                        allowed_to_answer: test.allowed_to_answer,
                        is_approved: test.is_approved,
                        is_blocked: test.is_blocked,
                        score: test.test_score > 0 ? test.test_score : '',
                        user_test_results: test.user_test_results
                    })
                })

                this.sections = []

                if (this.webcast_user_result_status != 2) {
                    this.sections.push({
                        value: this.user_progress ? this.user_progress > 100 ? 100 : this.user_progress : 0,
                        color: this.getDonutColor(this.user_progress)
                    })
                }
                else {
                    this.sections.push({
                        value: 100,
                        color: '#DB2828'
                    })
                }

                this.qty_webcast_activities = this.activities.length

                this.server_pagination.rowsNumber = this.activities.length

                this.loading = false
            }))
            .catch(e => {
                this.loading = false
                console.log(e)

                this.$q.notify({
                    message: this.$t('webcast_not_found'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })

                this.$router.push({ name: 'webcasts' })
            })
        },

        fetchWebcast() {
            return this.$axios.get(`/etraining_webcasts/webcasts/${this.$route.params.id}/`, this.getHeader)
        },

        fetchTests() {
            return this.$axios.get(`/etraining_webcasts/webcasts/${this.$route.params.id}/webcast_test/`, this.getHeader)
        },

        btnClicked(activity) {
            if (activity.type_slug === 'webcast') {
                this.$q.loading.show()

                this.$axios.get(`/etraining_webcasts/webcasts/${activity.id}/`, this.getHeader)
                .then(response => {
                    this.openWebcast(activity.id, response.data)
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
            else {
                this.$q.loading.show()

                this.$axios.get(`/etraining_webcasts/webcasts/${this.$route.params.id}/webcast_test/${activity.id}/`, this.getHeader)
                .then(response => {
                    this.test = response.data
                    this.$q.loading.hide()
                    this.show_modal_test = true
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
        },

        openWebcast(id, data) {
            this.$axios.get(`/etraining_webcasts/webcasts/${id}/open_webcast/`, this.getHeader)
            .then(response => {
                this.selected_webcast = data
                this.show_modal_webcast = true
                this.setUserOnlineFirebase()
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        hideModalWebcast() {
            this.show_modal_webcast = false
            this.setUserOfflineFirebase()
            this.requestActivities({ pagination: this.server_pagination })
        },

        hideModalTest() {
            this.show_modal_test = false
            this.requestActivities({ pagination: this.server_pagination })
        },

        getRowClass(activity) {
            if (activity.type_slug != 'webcast') {
                if (this.webcast_status != 4) return 'blocked-activity text-faded'
            }
            return 'cursor-pointer'
        },

        getDisableButton(activity) {
            if (!this.webcast_user_subscribed) return true

            if (activity.type_slug !== 'webcast') {
                if (this.webcast_status !== 4) return true
                else if (this.webcast_status === 4 && !activity.user_watch) return true
            } else return false
        },

        getIcon(slug) {
            switch(slug) {
                case 'webcast': return 'fal fa-broadcast-tower'
                break
                case 'conventional_test':
                case 'restart_test':
                case 'block_test': return 'fal fa-check-double'
                break
                case 'evaluated_quiz':
                case 'unevaluated_quiz': return 'fal fa-ballot-check'
                break
            }
        },

        getType(slug) {
            switch(slug) {
                case 'webcast': return 'webcast'
                break
                case 'conventional_test': return 'conventional_test'
                break
                case 'block_test': return 'block_test'
                break
                case 'restart_test': return 'restart_test'
                break
                case 'evaluated_quiz': return 'evaluated_quiz'
                break
                case 'unevaluated_quiz': return 'unevaluated_quiz'
                break
            }
        },

        getLabelBtn(activity) {
            if (activity.type_slug === 'webcast') return 'watch'
            else return 'answer'
        },

        getIconBtn(activity) {
            if (activity.type_slug === 'webcast') return 'fal fa-eye'
            else return 'fal fa-pen'
        },

        getPercentage(percentage) {
            if (!percentage) {
                return 0
            }
            else if (percentage < 100) {
                return parseInt(percentage)
            }
        },

        getDonutColor(percentage) {
            if (percentage > 0 && percentage <= 24) {
                return '#DB2828'
            }
            else if (percentage >= 25 && percentage <= 74) {
                return '#F2C037'
            }
            else if(percentage >= 75) {
                return '#21BA45'
            }
        },

        reloadActivity() {
            this.$axios.get(`/etraining_webcasts/webcasts/${this.$route.params.id}/`, this.getHeader)
            .then(response => {
                this.user_progress = response.data.user_progress ? parseInt(response.data.user_progress) : 0
                this.webcast_user_result_status = response.data.webcast_user_result_status

                // this.sections = []

                // if (this.webcast_user_result_status != 2) {
                //     this.sections.push({
                //         value: this.user_progress ? this.user_progress : 0,
                //         color: this.getDonutColor(this.user_progress)
                //     })
                // }
                // else {
                //     this.sections.push({
                //         value: 100,
                //         color: '#DB2828'
                //     })
                // }

            })
            .catch(e => {
                console.log(e)
            })
        },

        showCertificate() {
            if (this.webcast_user_result_status == 1) {
                this.$q.loading.show()

                this.$axios.get(`/etraining_webcasts/webcasts/${this.$route.params.id}/get_webcast_user_result_certificate/`, this.getHeader)
                .then(response => {
                    this.certificate_data = response.data
                    this.show_certificate = true
                    this.$q.loading.hide()
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
        },

        hideCertificate() {
            this.show_certificate = false
            this.certificate_data = []
        },

        setUserOnlineFirebase() {
            if (this.selected_webcast.status != 4) {
                let { uid } = firebase.auth().currentUser
                let userStatus = firebase.database().ref(`/webcast_user_status/${this.$route.params.id}/${uid}`)
                let userOnline = firebase.database().ref(`/webcast_user_online/${uid}`)

                let isOnlineForDatabase = {
                    st: 'on',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.$route.params.id.toString())
                }

                let isOfflineForDatabase = {
                    st: 'off',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.$route.params.id)
                }

                firebase.database().ref('.info/connected').on('value', (snapshot) => {
                    userStatus.onDisconnect().set(isOfflineForDatabase).then(() => {
                        userStatus.set(isOnlineForDatabase)
                    })
                })

                firebase.database().ref('.info/connected').on('value', (snapshot) => {
                    userOnline.onDisconnect().set(isOfflineForDatabase).then(() => {
                        userOnline.set(isOnlineForDatabase)
                    })
                })
            }
        },

        setUserOfflineFirebase() {
            if (this.selected_webcast.status != 4) {
                let { uid } = firebase.auth().currentUser
                if (uid) {
                    let userStatus = firebase.database().ref(`/webcast_user_status/${this.$route.params.id}/${uid}`)
                    let userOnline = firebase.database().ref(`/webcast_user_online/${uid}`)

                    let isOfflineForDatabase = {
                        st: 'off',
                        dt: firebase.database.ServerValue.TIMESTAMP,
                        we: parseInt(this.$route.params.id)
                    }

                    userStatus.set(isOfflineForDatabase)
                    userOnline.set(isOfflineForDatabase)
                }
            }
        },

        getHumanTimezone(location) {
            const gmt = moment.tz(location).format('z')
            if (gmt === 'GMT') {
                return `${gmt} 0`
            } else return `GMT ${gmt}`
        }
    },

    beforeRouteLeave (to, from, next) {
        if (this.show_modal_webcast) {
            this.setUserOfflineFirebase()
        }
        next()
    },

    async mounted () {
        await this.fetchWebcast()
        if (this.webcast_type === 2 && !this.transmission_downloaded) {
            this.$bind('firebase_webcast_data', db.collection('webcast').doc(`${this.webcast_id}`)).then(data => {
                this.firebase_webcast_data === data
            })
        }
    },

    created() {
        this.requestActivities({ pagination: this.server_pagination })
    },

    watch: {
        $route: function (to, from) {
            this.server_pagination = {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            },
            this.requestActivities({ pagination: this.server_pagination })
        }
    },
}
</script>

<style>

</style>
